import { atom } from "../../app-jotai";

import type { ShareRole, WorkspaceUser } from "./api";

/** The signed-in workspace user, or null. `undefined` = not yet loaded. */
export const currentUserAtom = atom<WorkspaceUser | null | undefined>(
  undefined,
);

/** The cloud scene currently open on the canvas (owner context), or null. */
export const activeSceneAtom = atom<{ id: string; name: string } | null>(null);

/**
 * When the app was opened via a public share link (#share=<token>), this tracks
 * the token + granted role so edits can sync back (edit links only).
 */
export const activeShareAtom = atom<{ token: string; role: ShareRole } | null>(
  null,
);

/** Auth dialog visibility. */
export const authDialogAtom = atom<boolean>(false);

/** "My scenes" dashboard dialog visibility. */
export const dashboardDialogAtom = atom<boolean>(false);

/** Bumped whenever the dashboard should refetch its scene/folder lists. */
export const workspaceRefreshAtom = atom<number>(0);

/**
 * Active presentation session: the ordered frame ids to step through and the
 * current slide index. Null when not presenting.
 */
export const presentationAtom = atom<{
  frameIds: string[];
  index: number;
} | null>(null);
